module.exports = __webpack_public_path__ + "img/tutore_ok.573731ca.png";